/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { callApi } from 'api/helpers/api.helpers';
import userApi from 'api/user.api';
import { useDebouncedCallback } from 'use-debounce';
import AssistiveText from './AssistiveText';
import TextWidget from './TextWidget';

export default function OrganizationNameWidget(props) {
  const [nameIsDuplicated, setNameIsDuplicated] = useState(false);
  const { onChange, rawErrors = [], registry } = props;
  const { t } = useTranslation();

  const onChangeDebounced = useDebouncedCallback(async (value) => {
    if (!value || value === '') {
      setNameIsDuplicated(false);
      registry.forceValidityState(true);
      return;
    }

    const result = await callApi(userApi.getOrganizationByName)(value);
    if (result?.id) {
      setNameIsDuplicated(true);
      registry.forceValidityState(false);
    } else {
      setNameIsDuplicated(false);
      registry.forceValidityState(true);
    }
  }, 500);

  return (
    <>
      <TextWidget
        {...props}
        size="small"
        hasWarning={nameIsDuplicated}
        onChange={(value) => {
          onChange(value);
          onChangeDebounced(value);
        }}
        error={rawErrors.length > 0}
      />
      {nameIsDuplicated && (
        <AssistiveText severity="warning">{t('user-management.organization.duplicated.name')}</AssistiveText>
      )}
    </>
  );
}
